<div class="superintendence-container">
  <div class="superintendence general-container">
    <div class="img-superintendence-logo"></div>
    <div (click)="goToForm()" class="text" [ngClass]="font?.size">
      <span *ngIf="!loading" [innerHTML]="data?.text + ' ' + '<strong>' + data?.button + '</strong>' "></span>
      <ion-skeleton-text *ngIf="loading" class="skeleton-line" animated></ion-skeleton-text>
    </div>
  </div>
</div>
